"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StatusPaper = void 0;
const styled_1 = __importDefault(require("@emotion/styled"));
const Paper_1 = require("./Paper");
const constants_1 = require("../constants");
const BORDER_WIDTH = constants_1.theme.border.radius.normal;
exports.StatusPaper = (0, styled_1.default)(Paper_1.Paper) `
  border-left: ${BORDER_WIDTH}px solid ${({ statusColor }) => statusColor};
  position: relative;

  ::before {
    content: '';
    position: absolute;
    top: ${-constants_1.theme.border.width.thin}px;
    left: -${BORDER_WIDTH}px;
    bottom: ${-constants_1.theme.border.width.thin}px;
    border-bottom-left-radius: ${constants_1.theme.border.radius.normal}px;
    border-top-left-radius: ${constants_1.theme.border.radius.normal}px;
    background-color: ${({ statusColor }) => statusColor};
    width: ${BORDER_WIDTH}px;
  }
`;
